<template>
  <div>
    <div class="flex flex-col sm:hidden">
      <h4 class="fs-16 font-medium mb-3">What’s included</h4>

      <ul>
        <li v-for="(inc, index) in included" :key="index" class="mb-3 flex">
          <span class="w-6 mr-2">
            <svg width="24" height="24" class="fill-current mr-2">
              <use xlink:href="/img/sprite.svg#ic_all-done"></use>
            </svg>
          </span>
          <span class="fs-14"> {{ inc }} </span>
        </li>
      </ul>

      <hr class="border border-black-light-2 my-5" />

      <ul class="list-reset row-gap-2">
        <li class="flex items-start mb-2">
          <span class="w-6 mr-2">
            <svg width="24" height="24" class="fill-current mr-2">
              <use xlink:href="/img/sprite.svg#ic_snorkel"></use>
            </svg>
          </span>
          <span class="fs-14"
            >Diving and other activities can be added on request</span
          >
        </li>
      </ul>
    </div>

    <div class="lg:hidden md:hidden">
      <div
        class="panel__container rounded-lg"
        data-question-id="whats-included"
      >
        <div
          class="panel__question cursor-pointer flex justify-between items-center"
          @click="toggleExpandCollapse($event, 'whats-included')"
        >
          <h4 class="fs-16 font-medium">What’s included</h4>
          <span class="icon rounded-full bg-white">
            <svg
              width="24"
              height="24"
              style="right: 10px"
              viewBox="0 0 24 24"
              fill="black"
            >
              <use xlink:href="/img/sprite.svg#ic_chevron-right"></use>
            </svg>
          </span>
        </div>
        <div
          class="panel__answer hidden mt-3"
          itemscope
          itemprop="acceptedAnswer"
          itemtype="https://schema.org/Answer"
        >
          <div itemprop="text">
            <ul>
              <li
                v-for="(inc, index) in included"
                :key="index"
                class="mb-3 flex"
              >
                <span class="w-6 mr-2">
                  <svg width="24" height="24" class="fill-current mr-2">
                    <use xlink:href="/img/sprite.svg#ic_all-done"></use>
                  </svg>
                </span>
                <span class="fs-14">
                  {{ inc }}
                </span>
              </li>
            </ul>

            <hr class="border border-black-light-2 my-5 sm:hidden" />

            <ul class="list-reset row-gap-2 sm:mt-2">
              <li class="flex items-start mb-2">
                <span class="w-6 mr-2">
                  <svg width="24" height="24" class="fill-current mr-2">
                    <use xlink:href="/img/sprite.svg#ic_snorkel"></use>
                  </svg>
                </span>
                <span class="fs-14"
                  >Diving and other activities can be added on request</span
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { totalDays } from "../../../helpers";
import uniqBy from "lodash/uniqBy";

function capitalizeFirstWord(transferName) {
  if (!transferName) return "";
  const words = transferName.split(" ").map((w) => w.toLowerCase());
  words[0] = words[0].charAt(0).toUpperCase() + words[0].slice(1).toLowerCase();
  return words.join(" ");
}

export default {
  props: ["allAvailableTransfers"],
  data() {
    return {
      included: [],
    };
  },
  mounted() {
    const total = totalDays(this.bookingDates[0], this.bookingDates[1], true);
    const accommodation = `${total} night${total > 1 ? "s" : ""} accommodation`;
    this.included = [accommodation, "Selected meal plan", "All taxes and fees"];

    if (this.allAvailableTransfers[0]) {
      const transferName = this.allAvailableTransfers[0].name;
      this.included.splice(2, 0, capitalizeFirstWord(transferName));
    }
  },
  computed: {
    ...mapState(["bookingDates"]),
  },
  methods: {
    totalDays(nights = false) {
      const fromDate = this.dates[0];
      const toDate = this.dates[1];

      if (fromDate && toDate) {
        return totalDays(fromDate, toDate, nights);
      } else if (fromDate && !toDate) {
        return totalDays(fromDate, fromDate);
      }
      return "";
    },
    toggleExpandCollapse(e, faqId) {
      // collpase other opening question
      const otherActiveQuestion = $(
        `.panel__container:not([data-question-id=${faqId}]).active`
      );
      if (otherActiveQuestion.length) {
        otherActiveQuestion
          .removeClass("active")
          .children(".panel__answer")
          .stop()
          .slideUp(300);
      }

      $(e.currentTarget)
        .parent()
        .toggleClass("active")
        .children(".panel__answer")
        .stop()
        .slideToggle(300);
    },
  },
};
</script>

<style scoped>
.panel__question,
.icon,
.icon svg {
  transition: 0.3s;
}

.panel__answer p:last-of-type {
  margin-bottom: 0;
}

.panel__container.active .icon {
  transform: rotateZ(90deg);
}
</style>
